import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { ComponentInterface } from "../../models/component.interface";
import { ComponentConfig } from "../../models/component-config.interface";
import { ImageWithHtmlComponent } from "../image-with-html/image-with-html.component";

@Component({
  selector: "app-link",
  templateUrl: "./link.component.html",
  styleUrls: []
})
export class LinkComponent
  implements ComponentInterface, OnInit, AfterViewInit {
  config: ComponentConfig;

  @ViewChild(ImageWithHtmlComponent)
  imageHtmlComponent: ImageWithHtmlComponent;
  isLoading: boolean;

  ngOnInit() {
    this.isLoading = true;
    if (this.imageHtmlComponent) {
      this.imageHtmlComponent.config = {
        name: "image",
        type: "image",
        imgSrc: this.config.imgSrc,
        text: this.config.text
      };
    }
    this.isLoading = false;
  }

  ngAfterViewInit() {
    this.imageHtmlComponent.config = {
      name: "image",
      type: "image",
      imgSrc: this.config.imgSrc,
      text: this.config.text
    };
    this.isLoading = false;
  }

  goToLink() {
    if (this.config.link) {
      window.open(this.config.link, "_blank");
    }
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/link/link.component.ts